import styled from 'vue-styled-components';
export default styled.a `
    color: #80DDFF;
    text-decoration-line: underline; 
`;
